<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "App",
  created() {
    // console.log(this.$route.query.token == undefined)
    // localStorage.setItem('token', this.$route.query.token == undefined?localStorage.getItem('token'):this.$route.query.token);//获取token 进行保存
    // this.$store.state.parameterUrl = this.$route.query.token == undefined?localStorage.getItem('token'):this.$route.query.token;
    // console.log(this.$route.query.token)
    // var mobile = localStorage.getItem("xq-mobile");
    // var appid = localStorage.getItem("xq-appid");
    // if (!mobile && !appid){
    //   this.$router.push("/login")
    // }
    // var apiName = this.API1url.API;
    // this.$get(apiName.Color,{
    //   token:localStorage.getItem('token')
    // }).then(res=>{
    //   if(res.code == '0000'){
    //     // console.log(res)
    //     // res.data.rgb = 'rgb(253, 1, 66)'   961d361e97db42178b459c3eac7380da
    //     // res.data.rgba = 'rgba(253, 1, 66,.2)'
    //     localStorage.setItem('bakColor', JSON.stringify(res.data));
    //   }
    // }).catch(res=>{
    //   Toast.fail('加载失败');
    // })
  },
  methods: {
    getQueryObject(url) {
      const requestStr = location.search.slice(1);
      const requestArray = requestStr.split("&");
      const obj = {};
      requestArray.forEach((item) => {
        const index = item.indexOf("=");
        const key = item.slice(0, index);
        const value = item.slice(index + 1);
        obj[key] = value;
      });
      return obj;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue